import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, unref as _unref, vModelText as _vModelText, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7ed4c0af"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Items Due", -1))
const _hoisted_2 = { key: 1 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Pay", -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: 1 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Due On")
], -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Description")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Subtotal")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Tax")
], -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Total")
], -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, [
  /*#__PURE__*/_createElementVNode("p", null, "Balance Due")
], -1))
const _hoisted_14 = {
  key: 0,
  class: "row"
}
const _hoisted_15 = ["onUpdate:modelValue", "onClick"]
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, null, -1))
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { key: 2 }
const _hoisted_20 = { key: 3 }
const _hoisted_21 = {
  key: 1,
  class: "text-center"
}
const _hoisted_22 = { class: "totals" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = { class: "payments" }
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Payment Amount", -1))
const _hoisted_27 = { class: "row" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_29 = ["disabled"]
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Convenience Fee", -1))
const _hoisted_31 = { class: "row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_33 = ["value"]
const _hoisted_34 = {
  key: 0,
  class: "fee-note"
}
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Total Amount with Convenience Fee", -1))
const _hoisted_36 = { class: "row" }
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "$", -1))
const _hoisted_38 = ["value"]
const _hoisted_39 = ["disabled"]
const _hoisted_40 = ["onSubmit"]
const _hoisted_41 = ["disabled"]
const _hoisted_42 = /*#__PURE__*/_createTextVNode(" Make Payment ")
const _hoisted_43 = ["disabled"]
const _hoisted_44 = ["href"]

import { onMounted, ref, watch } from "vue";
import {
  paymentAccountInterface,
  lineItemInterface,
  PaymentsInterface,
  // eslint-disable-next-line
  LedgerInterface,
} from "@/types/customers";
import { paymentMethodInterface } from "@/types/customers";
import api from "@virgodev/bazaar/functions/api";
// const router = useRouter();
import BaseSpinner from "@/components/BaseSpinner.vue";
import OutstandingFeeBanner from "@/components/OutstandingFeeBanner.vue";
import { useRouter, useRoute } from "vue-router";
import Payment from "@/components/Payment.vue";
import PaymentResponse from "@/components/PaymentResponse.vue";

import { storeToRefs } from "pinia";
import { useStore } from "../../store";
import moment from "moment";

export default /*#__PURE__*/_defineComponent({
  props: {
  customerId: {
    type: [Number, String],
    required: true,
  },
  customerName: {
    type: String,
    required: true,
  },
  facilityId: {
    type: String,
    default: null,
  },
},
  setup(__props) {

const props = __props

// import { useRouter } from "vue-router";
const formErrors = ref<Record<string, string[]>>({});
const formSubmitting = ref(false);
const proceedToPayment = ref(false);
const customer = ref();
const router = useRouter();
const route = useRoute();
const responseModal = ref(false);
const successfulPayment = ref(false);
const errorPaymentMessage = ref("");
const store = useStore();
const { userData } = storeToRefs(store);
const api_settings = userData.value.chosenFacility.api_settings;
const convenienceFeeSetting =
  userData.value.chosenFacility.require_convenience_fee;
const facilityCountry = userData.value.chosenFacility.country;
const errors = ref("");
const subtotal = ref(Number(0.0));
const credit = ref(Number(0.0));
const amountDue = ref(Number(0.0));
const paymentAmount = ref(Number(0));
const status = ref("loading");
const convenienceFeeAmount = ref(0.0);
// Previously-missed convenience fee for this customer (from OutstandingFeeBanner).
// The backend folds it into the single charge; shown here so the displayed
// fee/total reflect what the customer is actually charged.
const missedFeeAmount = ref(0);
const urlForAuth = ref("");
const chosenSavedCard = ref({});
const paymentAccounts = ref(Array<paymentAccountInterface>());
const paymentLink = ref();
const formFields = ref({
  payments: ref(Array<PaymentsInterface>()),
  payment_method: ref({} as paymentMethodInterface),
});

const rentals = ref();
const lineItems = ref();
const availableAccount = ref();

function addPaymentMethod(e: paymentAccountInterface) {
  formFields.value.payment_method = e.payment_method;
}
const tokenFee = ref();
async function getPaymentAccounts() {
  errors.value = "";
  let id = props.customerId;
  if (api_settings.use_contact_id) {
    id = customer.value.contact_id;
  }
  const response = await api({
    url: `payment_accounts/?id=${id}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    paymentAccounts.value = response.body;
    if (api_settings.filter_payment_accounts) {
      paymentAccounts.value = response.body.filter(
        (item: { account: number; card_number: number }) =>
          item.account || item.card_number
      );
    }
    if (formFields.value.payment_method.payment_method_id) {
      chosenSavedCard.value = paymentAccounts.value.filter(
        (item: { id: string }) =>
          item.id == formFields.value.payment_method.payment_method_id
      )[0];
    } else {
      let foundAvailable = false;
      let allAccounts = response.body;
      if (
        allAccounts &&
        api_settings.get_available_account &&
        formFields.value.payment_method.reuseable
      ) {
        for (let account of allAccounts) {
          if (!account.account_or_card_number) {
            availableAccount.value = account;
            foundAvailable = true;
            break;
          }
        }
        if (!foundAvailable) {
          availableAccount.value = allAccounts[0];
        }
      }
    }
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}
watch(paymentAmount, () => {
  if (paymentAmount.value) {
    convenienceFeeAmount.value = (paymentAmount.value / 100) * 4;
  }
});
const invoices = ref();
onMounted(async () => {
  await getCustomer();
  await getLedgers();
  await getInvoiceList();
  status.value = "completed";
});

function setCurrentLedgerIdsFromRentals() {
  if (
    customer.value.current_ledger_ids &&
    customer.value.current_ledger_ids.length
  ) {
    return;
  }
  if (!Array.isArray(rentals.value)) {
    return;
  }
  customer.value.current_ledger_ids = rentals.value
    .map((rental: LedgerInterface) => rental.id)
    .filter(Boolean);
}

async function getLedgers() {
  errors.value = "";
  let response;
  if (!api_settings.use_contact_id) {
    if (
      !api_settings.customer_id_with_ledgers &&
      customer.value.current_ledger_ids
    ) {
      response = await api({
        url: `ledgers/?only_ids=${customer.value.current_ledger_ids.join(
          ","
        )}&include_as_object=events&facilityId=${props.facilityId}`,
      });
    } else {
      response = await api({
        url: `ledgers/?id=${props.customerId}&facilityId=${props.facilityId}`,
      });
    }

    if (response.status == 200) {
      if (response.body.ledgers) {
        rentals.value = response.body.ledgers;
      } else {
        rentals.value = response.body;
      }
      setCurrentLedgerIdsFromRentals();
    } else {
      errors.value =
        "Unable to communicate with the server. Please check your " +
        "connection and try again.";
    }
  } else {
    rentals.value = customer.value.rentals;
    customer.value.current_ledger_ids = [];
    for (let rental of rentals.value) {
      customer.value.current_ledger_ids.push(rental.id);
    }
  }
}
async function getConvenienceFeeToken() {
  let method;
  let payment_information;
  if (Object.keys(chosenSavedCard.value).length) {
    method = null;
  } else if (formFields.value.payment_method.card_number) {
    method = formFields.value.payment_method;
    let card_exp = method.expiration_date.split("/");
    let country = method.billing_address_attributes.country;
    if (!country) {
      country = facilityCountry;
    }
    if (country.includes("United States")) {
      country = "US";
    } else if (country.includes("Canada")) {
      country = "CA";
    }

    payment_information = {
      card: {
        name: customer.value.first_name + " " + customer.value.last_name,
        number: method.card_number,
        expMonth: card_exp[0],
        address: {
          postalCode: method.billing_address_attributes.postal,
          country: country,
          region: method.billing_address_attributes.state,
          streetAddress: method.billing_address_attributes.address1,
          city: method.billing_address_attributes.city,
        },
        expYear: "20" + card_exp[1],
        cvc: method.security_code,
      },
    };
  } else {
    method = formFields.value.payment_method;
    let accountType = method.account_type;
    if (accountType) {
      if (accountType == "checking") {
        accountType = "PERSONAL_CHECKING";
      } else if (accountType == "savings") {
        accountType = "PERSONAL_SAVINGS";
      } else if (accountType == "businessChecking") {
        accountType = "BUSINESS_CHECKING";
      }
    }
    payment_information = {
      bankAccount: {
        name: customer.value.first_name,
        accountNumber: method.account_number,
        accountType: accountType,
        phone: customer.value.phone_numbers[0].unformatted_number,
        routingNumber: method.routing_number,
      },
    };
  }
  if (method) {
    const json = JSON.parse(JSON.stringify(payment_information));
    let url = `generate_token_convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`;
    const responseData = await api({
      url,
      method: "POST",
      json,
    });
    if ([200, 201].includes(responseData.status)) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      tokenFee.value = responseData.body.value;
    }
  }
}
async function convenienceFee() {
  await getConvenienceFeeToken();

  const json = JSON.parse(
    JSON.stringify({
      token: tokenFee.value,
      chosen_saved_payment: chosenSavedCard.value,
      payment_method: formFields.value.payment_method.kind,
      save_payment: formFields.value.payment_method.reuseable,
      total_amount: convenienceFeeAmount.value.toFixed(2),
      tenant: {
        name: customer.value.first_name + " " + customer.value.last_name,
        id: props.customerId,
      },
    })
  );

  let url = `convenience_fee/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    console.log("Successful convenience fee");
  } else if (responseData.status == 409) {
    if (
      responseData.body.errors &&
      responseData.body.errors[0].message.includes("Card already exists.")
    ) {
      await quickBooksAuthCheck();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function quickBooksAuthCheck() {
  let url = `auth_check/?facilityId=${props.facilityId}&id=${props.customerId}`;
  const responseData = await api({
    url,
    method: "GET",
  });
  if ([200, 201].includes(responseData.status)) {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    if (responseData.body.url) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      urlForAuth.value = responseData.body.url;
    } else {
      await convenienceFee();
    }
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
    errorPaymentMessage.value = responseData.body.errors;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}
async function updateSelectedItems(item: lineItemInterface) {
  if (!item.pay) {
    if (item.total) {
      if (api_settings.use_invoice_payment) {
        for (let line of item.invoices) {
          formFields.value.payments.push({
            invoice_id: line.invoice_id,
            amount: line.amount.toString(),
            kind: "balance",
            period_start: line.start_date,
            period_end: line.end_date,
          });
        }
      } else {
        formFields.value.payments.push({
          ledger_id: item.id,
          amount: item.total.toString(),
          kind: "balance",
        });
      }
    }

    paymentAmount.value += Number(item.total);
  } else {
    if (api_settings.use_invoice_payment) {
      for (let line of formFields.value.payments) {
        let invoices_to_remove = item.invoices.filter(
          (item) => item.id && line.invoice_id == item.id
        );
        if (invoices_to_remove) {
          for (let invoice of invoices_to_remove) {
            formFields.value.payments = formFields.value.payments.filter(
              (item) => item.invoice_id != invoice.id
            );
            paymentAmount.value -= Number(invoice.amount);
          }
        }
      }
    } else {
      let index = formFields.value.payments.findIndex(function (
        selected: PaymentsInterface
      ) {
        return selected.ledger_id === item.id;
      });
      if (index != -1) {
        formFields.value.payments.splice(index, 1);
        paymentAmount.value -= Number(item.total);
      }
    }
  }
  paymentAmount.value = Number(paymentAmount.value.toFixed(2));
}
async function submitForm() {
  successfulPayment.value = false;
  if (
    paymentAmount.value != amountDue.value &&
    !api_settings.use_unit_id_for_transaction &&
    !api_settings.use_invoice_payment
  ) {
    let split_amount =
      Number(paymentAmount.value) / formFields.value.payments.length;
    for (let due of formFields.value.payments) {
      due.amount = split_amount.toString();
      due.kind = "custom";
    }
  }

  const json = JSON.parse(JSON.stringify(formFields.value));
  if (!json.payment_method.payment_method_id) {
    delete json.payment_method.payment_method_id;
  }
  formErrors.value = {};
  formSubmitting.value = true;

  let url = `transactions/?id=${props.customerId}&facilityId=${props.facilityId}`;

  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    if (convenienceFeeSetting) {
      if (formFields.value.payment_method.payment_method_id) {
        await getPaymentAccounts();
      }
      if (formFields.value.payment_method.kind != "check") {
        await quickBooksAuthCheck();
      }
    }
    if (
      formFields.value.payment_method.reuseable &&
      api_settings.get_available_account
    ) {
      await getPaymentAccounts();
      saveAccount();
    }
    if (
      api_settings.payment_link &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      responseData.body.data &&
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      responseData.body.data.paymentLink
    ) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      paymentLink.value = responseData.body.data.paymentLink;
    } else {
      successfulPayment.value = true;
    }
  } else if (responseData.status === 400) {
    if (responseData.body.meta) {
      formErrors.value = { server_error: [responseData.body.meta.message] };
      errorPaymentMessage.value = responseData.body.meta.message;
    } else {
      formErrors.value = { server_error: [responseData.body.error] };
      errorPaymentMessage.value = responseData.body.error;
    }
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
  responseModal.value = true;
  formSubmitting.value = false;
}

async function saveAccount() {
  const json = JSON.parse(JSON.stringify(formFields.value));
  let url = `payment_accounts/?facilityId=${props.facilityId}&id=${availableAccount.value.id}`;
  const responseData = await api({
    url,
    method: "POST",
    json,
  });
  if ([200, 201].includes(responseData.status)) {
    console.log("Successfully saved account");
  } else if (responseData.status === 400 || responseData.status === 406) {
    formErrors.value = responseData.body;
  } else {
    formErrors.value = {
      non_field_errors: [
        "Unable to communicate with the server. Please check your " +
          "connection and try again.",
      ],
    };
  }
}

async function modalClosed() {
  if (successfulPayment.value) {
    router.push(
      typeof route.query.next === "string"
        ? route.query.next
        : {
            name: "customer_detail_storedge",
            params: {
              id: props.customerId,
              facilityId: props.facilityId,
            },
          }
    );
  }
  responseModal.value = false;
  errorPaymentMessage.value = "";
}
async function getInvoiceList() {
  errors.value = "";
  invoices.value = [];
  lineItems.value = [];
  if (
    customer.value.current_ledger_ids &&
    customer.value.current_ledger_ids.length != 0
  ) {
    for (let ledgerId of customer.value.current_ledger_ids) {
      const response = await api({
        url: `invoices/?id=${ledgerId}&facilityId=${props.facilityId}&exclude=paid`,
        method: "GET",
      });
      if (response.status == 200) {
        let ledger = rentals.value.filter(
          (ledg: LedgerInterface) => ledg.id == ledgerId
        )[0];
        if (
          ledger.current_account_balance > 0 ||
          !api_settings.invoice_has_status
        ) {
          let total = 0;

          let ledgerList = ref(Array<lineItemInterface>());

          if (api_settings.invoice_has_status) {
            total += Number(ledger.current_account_balance);
          } else {
            total += ledger.balance;
          }
          let invoices = response.body;
          if (response.body.invoices) {
            invoices = response.body.invoices;
            for (let invoice of invoices) {
              if (
                invoice.status != "closed" &&
                moment(invoice.due_on).isSameOrBefore(moment())
              ) {
                let line_items = [];
                for (let item of invoice.line_items) {
                  item.due_on = invoice.due_on;
                  item.account_balance_on_due_date =
                    invoice.account_balance_on_due_date;
                  if (item.current_product_code.slice(0, 4) == "Unit") {
                    if (
                      item.current_product_code.split("#")[1] ==
                      ledger.unit.name
                    ) {
                      line_items.push(item);
                    }
                  } else {
                    line_items.push(item);
                  }
                }
                ledgerList.value = ledgerList.value.concat(line_items);
              }
            }
          } else {
            ledgerList.value = invoices;
          }

          subtotal.value += Number(total);
          if (api_settings.use_unit_id_for_transaction) {
            let ledgerTotal = total;
            let pay = true;
            if (ledgerList.value.length == 0) {
              pay = false;
            } else {
              ledgerTotal = 0;
              for (let item of ledgerList.value) {
                ledgerTotal += Number(item.total);
              }
            }
            if (api_settings.use_invoice_payment) {
              for (let item of ledgerList.value) {
                formFields.value.payments.push({
                  invoice_id: item.invoice_id,
                  amount: total.toString(),
                  kind: "balance",
                  period_start: item.start_date,
                  period_end: item.end_date,
                });
              }
            } else {
              formFields.value.payments.push({
                unit_id: ledger.unit.id,
                ledger_id: ledgerId,
                amount: ledgerTotal.toString(),
                kind: "balance",
              });
            }
            lineItems.value.push({
              id: ledgerId,
              unitName: ledger.unit.name,
              total: total,
              invoices: ledgerList.value,
              pay: pay,
            });
          } else {
            lineItems.value.push({
              id: ledgerId,
              unitName: ledger.unit.name,
              total: total,
              invoices: ledgerList.value,
              pay: true,
            });
            if (api_settings.use_invoice_payment) {
              for (let item of ledgerList.value) {
                formFields.value.payments.push({
                  invoice_id: item.invoice_id,
                  amount: total.toString(),
                  kind: "balance",
                  period_start: item.start_date,
                  period_end: item.end_date,
                });
              }
            } else {
              formFields.value.payments.push({
                ledger_id: ledgerId,
                amount: total.toString(),
                kind: "balance",
              });
            }
          }

          amountDue.value = subtotal.value;
          paymentAmount.value = Number(subtotal.value.toFixed(2));
        }
      } else {
        errors.value =
          "Unable to communicate with the server. Please check your " +
          "connection and try again.";
      }
    }
  }
}
async function getCustomer() {
  errors.value = "";
  const response = await api({
    url: `customers/?id=${props.customerId}&facilityId=${props.facilityId}`,
  });
  if (response.status == 200) {
    customer.value = response.body[0];
  } else {
    errors.value =
      "Unable to communicate with the server. Please check your " +
      "connection and try again.";
  }
}

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_BaseAlert = _resolveComponent("BaseAlert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_RouterLink, {
      to: {
      name: 'customer_detail_storedge',
      params: { id: __props.customerId, facilityId: __props.facilityId },
    }
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Customer: " + _toDisplayString(__props.customerName), 1)
      ]),
      _: 1
    }, 8, ["to"]),
    _createElementVNode("h1", null, "Make a Payment for " + _toDisplayString(__props.customerName), 1),
    _createVNode(OutstandingFeeBanner, {
      "facility-id": __props.facilityId,
      "customer-id": __props.customerId,
      onTotal: _cache[0] || (_cache[0] = ($event: any) => (missedFeeAmount.value = $event))
    }, null, 8, ["facility-id", "customer-id"]),
    _hoisted_1,
    (status.value === 'loading')
      ? (_openBlock(), _createBlock(BaseSpinner, {
          key: 0,
          preset: "large"
        }))
      : (_openBlock(), _createElementBlock("fieldset", _hoisted_2, [
          (lineItems.value && lineItems.value.length)
            ? (_openBlock(), _createElementBlock("table", _hoisted_3, [
                _createElementVNode("tr", null, [
                  (!proceedToPayment.value)
                    ? (_openBlock(), _createElementBlock("th", _hoisted_4, _hoisted_6))
                    : (_openBlock(), _createElementBlock("th", _hoisted_7)),
                  _hoisted_8,
                  _hoisted_9,
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(lineItems.value, (item) => {
                  return (_openBlock(), _createElementBlock(_Fragment, {
                    key: item.id + 'item'
                  }, [
                    (rentals.value)
                      ? (_openBlock(), _createElementBlock("h3", _hoisted_14, [
                          (!proceedToPayment.value)
                            ? _withDirectives((_openBlock(), _createElementBlock("input", {
                                key: 0,
                                "onUpdate:modelValue": ($event: any) => ((item.pay) = $event),
                                class: "form-check-input",
                                type: "checkbox",
                                onClick: ($event: any) => (updateSelectedItems(item))
                              }, null, 8, _hoisted_15)), [
                                [_vModelCheckbox, item.pay]
                              ])
                            : _createCommentVNode("", true),
                          _createTextVNode(" Unit " + _toDisplayString(item.unitName) + " - Balance Due $" + _toDisplayString(Number(item.total).toFixed(2)), 1)
                        ]))
                      : _createCommentVNode("", true),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.invoices, (invoice) => {
                      return (_openBlock(), _createElementBlock("tr", {
                        key: invoice.id + 'invoice'
                      }, [
                        _hoisted_16,
                        (invoice.due_on)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_17, _toDisplayString(invoice.due_on.split("T")[0]), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_18)),
                        _createElementVNode("td", null, [
                          _createTextVNode(_toDisplayString(invoice.full_description) + " ", 1),
                          (invoice.description)
                            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                _createTextVNode(_toDisplayString(invoice.description), 1)
                              ], 64))
                            : _createCommentVNode("", true)
                        ]),
                        _createElementVNode("td", null, "$" + _toDisplayString(Number(invoice.subtotal).toFixed(2)), 1),
                        _createElementVNode("td", null, "$" + _toDisplayString(Number(invoice.tax_total).toFixed(2)), 1),
                        (!_unref(api_settings).use_contact_id)
                          ? (_openBlock(), _createElementBlock("td", _hoisted_19, " $" + _toDisplayString(Number(invoice.total.toFixed(2))), 1))
                          : (_openBlock(), _createElementBlock("td", _hoisted_20, "$" + _toDisplayString(invoice.total), 1)),
                        _createElementVNode("td", null, "$" + _toDisplayString(Number(invoice.account_balance_on_due_date).toFixed(2)), 1)
                      ]))
                    }), 128))
                  ], 64))
                }), 128))
              ]))
            : (_openBlock(), _createElementBlock("p", _hoisted_21, "No items")),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("p", null, "Subtotal $" + _toDisplayString(subtotal.value.toFixed(2)), 1),
            _hoisted_23,
            _createElementVNode("p", null, "Credit $" + _toDisplayString(credit.value.toFixed(2)), 1),
            _hoisted_24,
            _createElementVNode("p", null, "Amount Due $" + _toDisplayString(amountDue.value.toFixed(2)), 1)
          ]),
          _createElementVNode("div", _hoisted_25, [
            _hoisted_26,
            _createElementVNode("div", _hoisted_27, [
              _hoisted_28,
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((paymentAmount).value = $event)),
                type: "decimal",
                disabled: proceedToPayment.value
              }, null, 8, _hoisted_29), [
                [_vModelText, paymentAmount.value]
              ])
            ]),
            (_unref(convenienceFeeSetting))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _hoisted_30,
                  _createElementVNode("div", _hoisted_31, [
                    _hoisted_32,
                    _createElementVNode("input", {
                      value: Number((convenienceFeeAmount.value + missedFeeAmount.value).toFixed(2)),
                      type: "decimal",
                      disabled: ""
                    }, null, 8, _hoisted_33)
                  ]),
                  (missedFeeAmount.value > 0)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_34, " Includes $" + _toDisplayString(Number(convenienceFeeAmount.value).toFixed(2)) + " current fee + $" + _toDisplayString(Number(missedFeeAmount.value).toFixed(2)) + " previously missed fee. ", 1))
                    : _createCommentVNode("", true),
                  _hoisted_35,
                  _createElementVNode("div", _hoisted_36, [
                    _hoisted_37,
                    _createElementVNode("input", {
                      value: 
              Number(
                (
                  Number(paymentAmount.value) +
                  Number(convenienceFeeAmount.value) +
                  Number(missedFeeAmount.value)
                ).toFixed(2)
              )
            ,
                      type: "decimal",
                      disabled: ""
                    }, null, 8, _hoisted_38)
                  ])
                ], 64))
              : _createCommentVNode("", true)
          ]),
          (!proceedToPayment.value)
            ? (_openBlock(), _createElementBlock("button", {
                key: 2,
                class: "btn",
                disabled: paymentAmount.value <= 0 || formFields.value.payments.length == 0,
                onClick: _cache[2] || (_cache[2] = ($event: any) => (proceedToPayment.value = true))
              }, " Proceed to Payment Summary ", 8, _hoisted_39))
            : _createCommentVNode("", true),
          (proceedToPayment.value)
            ? (_openBlock(), _createElementBlock("form", {
                key: 3,
                class: "large-width-centered",
                onSubmit: _withModifiers(submitForm, ["prevent"])
              }, [
                _createVNode(Payment, {
                  "facility-id": __props.facilityId,
                  "customer-id": __props.customerId.toString(),
                  onPaymentMethod: addPaymentMethod
                }, null, 8, ["facility-id", "customer-id"]),
                _createElementVNode("button", {
                  class: "btn",
                  type: "submit",
                  disabled: formSubmitting.value
                }, [
                  _hoisted_42,
                  (formSubmitting.value)
                    ? (_openBlock(), _createBlock(BaseSpinner, { key: 0 }))
                    : _createCommentVNode("", true)
                ], 8, _hoisted_41),
                _createElementVNode("button", {
                  class: "btn",
                  disabled: formSubmitting.value,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (proceedToPayment.value = false))
                }, " Adjust Payment Amount ", 8, _hoisted_43),
                (formErrors.value.server_error !== undefined)
                  ? (_openBlock(), _createBlock(_component_BaseAlert, {
                      key: 0,
                      variant: "danger",
                      class: "js-form-error",
                      dismissible: "",
                      onDismissed: _cache[4] || (_cache[4] = ($event: any) => (formErrors.value = {}))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(formErrors.value.server_error[0]), 1)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ], 40, _hoisted_40))
            : _createCommentVNode("", true)
        ])),
    (responseModal.value)
      ? (_openBlock(), _createBlock(PaymentResponse, {
          key: 2,
          error: errorPaymentMessage.value,
          success: successfulPayment.value,
          "payment-link": paymentLink.value,
          onModalClosed: modalClosed
        }, null, 8, ["error", "success", "payment-link"]))
      : _createCommentVNode("", true),
    (urlForAuth.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 3,
          href: urlForAuth.value,
          target: "_blank",
          rel: "noopener noreferrer"
        }, "Regenerate Quickbooks connection", 8, _hoisted_44))
      : _createCommentVNode("", true)
  ], 64))
}
}

})